<template>
  <v-container fluid text-xs-center>
    <v-layout row wrap light>
      <v-flex xs12>
        <h1>Prowadzący</h1>
      </v-flex>
      <v-flex 
        v-for="(leader, i) in leaders" 
        :key="`lead${i}`"
        xs12
        sm6
        transition="scale-transition">
        <v-hover>
          <v-card
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            class="mx-auto clickable black--text mb-4"
            color="white"
            @click="selected = leader"
            height="100%"
          >
            <v-img
              :aspect-ratio="16/9"
              :src="leader.image"
            ></v-img>
            <v-card-title>
              <div>
                <span class="headline">{{ leader.name }}</span>
                <div v-html="leader.description"  />
              </div>
            </v-card-title>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      selected: null,
      leaders: [
        {
          name: 'Piotr Pałka',
          image: this.imageURL(1),
          description: '<p>Dyrygent, kompozytor, śpiewak. Absolwent Akademii Muzycznej w Krakowie. Od 1993 komponuje i opracowuje utwory chóralne, które można usłyszeć w kościołach Krakowa i innych miast w Polsce. Jego zainteresowanie muzyką wokalną przyczyniło się do założenia w 1999 roku mieszanego chóru „Voce Angeli”, działającego przy bazylice oo. Franciszkanów w Krakowie, którego obecnie jest dyrygentem. Jako śpiewak współpracował z Zubinem Mehtą, Helmuthem Rillingiem, Henrykiem Mikołajem Góreckim, Krzysztofem Pendereckim, Wojciechem Kilarem, Antonim Witem, Łukaszem Borowiczem i Stanisławem Krawczyńskim. Jest twórcą szeregu kompozycji i opracowań, takich jak: Tryptyk Rzymski Jana Pawła II, Missa in Basilica Cracoviensi Sancti Francisci, hymnu Ogólnopolskiego Spotkania Młodzieży z Benedyktem XVI – Nie lękajcie się, a także Oratorium Braniewskiego "Mikołaj Kopernik". Swoim doświadczeniem i umiejętnościami chętnie dzieli się podczas sesji warsztatów muzyki liturgicznej.</p>',
          web: 'http://piotrpalka.pl'
        },
        {
          name: 'Paweł Bębenek',
          image: this.imageURL(3),
          description: `<p>Muzyk, amator-miłośnik z ponad dwudziestoletnim doświadczeniem praktyki: śpiewa, komponuje, dyryguje. Związany ze środowiskiem muzycznym przy krakowskim klasztorze dominikanów.  Muzyką liturgiczną zainteresował się w 1989 roku, początkowo jako chórzysta. W 1993 roku jako śpiewak rozpoczął pracę z „Bractwem Lutni z Dworu na Wysokiej”, z którym występował podczas wielu koncertów i festiwali w kraju i za granicą. Zajmuje się muzyczną tradycją Kościoła, jest autorem wykonywanych w kraju i za granicą kompozycji autorskich oraz aranżacji dawnych pieśni kościelnych. Nakładem wydawnictwa Edycja Świętego Pawła wydał dwie płyty autorskie: „Dzięki Ci Panie. Msza o Miłosierdziu” oraz „Boże mój szukam Ciebie”. Nakładem Dominikańskiego Ośrodka Liturgicznego w 2009 r. została wydana płyta z kolędami pt. „Gdy się rodzi Zbawca świata”.</p>
            <p>Sam mówi, że jego muzyka jest efektem poszukiwania Boga Stwórcy i zachwytu nad Jego Pięknem. Współpracuje z wieloma osobami zajmującymi się muzyką dawną i liturgiczną, m.in. z Antonim Pilchem (Bractwo Lutni), Marcinem Bornus-Szczycińskim (Bornus Consort), Stanisławem Szczycińskim (Mikroklimat), Taivo Niitvägi (Linnamuusikud, Tallin), Andriejem Kotowem (Sirin, Moskwa), Aleksandrem Tomczykiem (Studium Musicae Cracoviensae, Kraków) współpracował także z muzykami z branży rozrywkowej: Marcinem i Janem Pospieszalskimi, Piotrem Baronem, Joachimem Menclem, Andrzejem Lampertem. Podczas jednego z koncertów Bractwa Lutni, które wykonywało pieśni pasyjne skomponowane i zaaranżowane przez Pawła improwizował Tomasz Stańko.  Od kilku lat poświęca się prowadzeniu warsztatów muzyki liturgicznej w kraju i za granicą.</p>`,
          web: 'http://pawelbebenek.pl'
        }
      ]
    }
  },
  methods: {
    imageURL: function(id) {
      return require('./../assets/img/team/' + id + '.jpg')
    }
  }
}
</script>

<style>
.clickable {
  cursor: pointer;
}
</style>

